import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import injectTapEventPlugin from 'react-tap-event-plugin';

injectTapEventPlugin();

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js